<template>
<div>
  <el-dialog title="选择房产" :visible.sync="dialogVisible" :close-on-click-modal="false" width="310px">
    <div style="height: 350px;overflow-y: scroll">
      <erp-tree-status-common @node-click="nodeClick" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false;callback=undefined">取 消</el-button>
      <el-button @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import ErpTreeStatusCommon from "../../Common/erp-tree-status-common";
export default {
  name: "SelectProjectHouse",
  components: {ErpTreeStatusCommon},
  data(){
    return{
      dialogVisible:false,
      tree_str:"",
      id:"",
      project_id:"",
      project_name:"",
      tree_obj:{},
      name:"id",
      value:"",
      callback:null,
    }
  },
  mounted() {

  },
  methods:{
    show({name='id',value=""},callback){
      const that = this;
      that.dialogVisible=true;
      that.name=name||"";
      that.value=value||"";
      that.callback=callback;
    },
    getData(){
      let data={};
      const that = this;
      if(that.value) {
        if(that.value.match(/^\d*/g)&&that.value.match(/^\d*/g).length){

        }else {

        }
        ERP.getRequest({url:"admin/",data:{}},ret=>{

        })
      }
    },
    nodeClick(data){
      const that = this;
      that.tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      that.id=data.tree[data.tree.length-1].id;
      that.project_id=data.tree[0].id;
      that.project_name=data.tree[0].name;

    },
    submit(){
      const that = this;
      typeof that.callback==="function"&&that.callback({
        tree_obj:that.tree_obj,
        tree_str:that.tree_str,
        id:that.id,
        project_id:that.project_id,
        project_name:that.project_name
      })
      that.dialogVisible=false;
      that.callback=undefined;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectProjectHouse.vue